import { ChevronsUpDown } from "lucide-react";
import React from "react";
import { BaseSortableIconContainer } from "./styled";
import { jsx as _jsx } from "react/jsx-runtime";
function SortableIcon() {
  return /*#__PURE__*/_jsx(BaseSortableIconContainer, {
    children: /*#__PURE__*/_jsx(ChevronsUpDown, {
      color: "currentColor"
    })
  });
}
export default SortableIcon;